import React from 'react';

import { Spinner, View } from 'src/components/basic';
import { userFullName } from 'src/helpers';
import { HeaderBack } from 'src/components/mobile/HeaderBack';

import { DoctorDetail } from 'src/components/mobile/DoctorDetail';
import doctorModel from '../doctorModel';

export const Doctor = ({ onSendMsg, onBook, onBack }) => {
  doctorModel.use();

  const doctor = doctorModel.state.doctor || {};

  return (
    <View
      style={{
        height: '100%',
        backgroundColor: 'white'
      }}
    >
      <HeaderBack onBack={onBack} title={userFullName(doctor, true)} />
      {doctorModel.getApiState('doctor_detail').loading ? (
        <View style={{ margin: 'auto' }}>
          <Spinner />
        </View>
      ) : (
        <DoctorDetail
          doctor={doctor}
          selectedMonth={doctorModel.selectedMonth}
          selectedDay={doctorModel.selectedDay}
          selectedDate={doctorModel.state.selectedDate}
          slotsMonth={doctorModel.state.slotsMonth}
          hospitalName={
            doctorModel.state.clinic
              ? userFullName(doctorModel.state.clinic)
              : doctor.hospitalName?.split('_')[0]
          }
          locations={doctorModel.state.hospitals}
          onSendMsg={() => {
            onSendMsg(doctorModel.state.doctor);
          }}
          onBook={() => {
            onBook(doctorModel.state.doctor);
          }}
        />
      )}
    </View>
  );
};
